import { render, staticRenderFns } from "./FieldHolder.vue?vue&type=template&id=f586e45a&"
import script from "./FieldHolder.vue?vue&type=script&lang=js&"
export * from "./FieldHolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports